<template>
  <section class="atlas">
    <img v-if="isMobile" class="atlas__img" src="../images/background/atlas_m.jpg" alt="atlas"></img>
    <img v-else class="atlas__img" src="../images/background/atlas.jpg" alt="atlas">
  </section>
</template> 

<script>
export default {
  data() {
    return {
      isMobile: window.innerWidth < 640
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../styles/constants.scss";

.atlas {
  margin-top: calcFontSize(0, 90, 320, 1920);
  
  &__img {
    width: 100%;
    max-height: 2400px;
    object-fit: cover;
  }
}
</style>
